import BaseCommand from "@/models/api/commands/BaseCommand";
import { CONTRACT_COMPONENT_TYPE_ENUM } from "@/static/contractComponentTypes";

export class ChangeComponentTypeCommand extends BaseCommand {
  CommandName = "ChangeComponentType";
  Command: { TmpId: string; Value: CONTRACT_COMPONENT_TYPE_ENUM };
  constructor(sessionId: string, operationId: string, tmpId: string, value: CONTRACT_COMPONENT_TYPE_ENUM) {
    super(sessionId, operationId);
    this.Command = { TmpId: tmpId, Value: value };
  }
}
